import { Controller } from "@hotwired/stimulus"

export default class CircularController extends Controller {
  static targets = ["element", "parent"]

  connect() {
    this.circularize()
  }

  circularize() {
    const parent = this.parentTarget
    const elements = this.elementTargets
    const containerHeight = parent.offsetHeight
    // console.log("containerHeight ", containerHeight)

    const radius = (containerHeight / 2) + (7 * elements.length); // Adjust the radius as needed
    
    let maxWidth = 0
    elements.forEach((element, index) => {
      const angle = (index / elements.length) * (2 * Math.PI)
      // get the current caluclated width of the element
      const height = element.offsetHeight
      if (height > maxWidth) {
        maxWidth = height
      }

      element.style.position = "absolute"
      element.style.transform = `rotate(${angle}rad) translateY(-${radius + (height / 2)}px) rotate(${-angle}rad)`
    })
    let hsize = 0;
    let wsize = 0;
    if (elements.length < 3) {
      wsize = maxWidth > containerHeight ? maxWidth : containerHeight;
      hsize = (maxWidth * 2) + containerHeight + (14 * elements.length);
    } else {
      wsize = (maxWidth * 2) + containerHeight + (14 * elements.length);
      hsize = (maxWidth * 2) + containerHeight + (14 * elements.length);
    }
    
    this.element.style = `width: ${wsize}px; height: ${hsize}px;`
    
  }
}